import { IAssessmentInvite } from "@/shared/hooks/initializer/use-initialize-candidate.hook";
import { Form, Modal } from "antd";
import { CustomInput } from "@/ui-components/commonComponents/Input/Input";
import { Button, ButtonColorType } from "@/ui-components/commonComponents/Button/Button";
import { SubmitButton } from "@/ui-components/commonComponents/Button/SubmitButton";
import { useState, useRef, useEffect } from "react";
import { notification } from "antd";

import style from "./style.module.css";

export default function RenameUserModal({
  candidateToRename,
  onClose,
  onRenameCandidate,
}: {
  candidateToRename: IAssessmentInvite;
  onClose: () => void;
  onRenameCandidate: (
    userId: number,
    fullName: string,
    onRenameSuccess: () => void,
    onRenameFailure: () => void,
  ) => void;
}) {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef<any>(null);

  // Ideally we could use a function defined outside of this component as the ref,
  // but that wasn't working as the input was being re-rendered on every keystroke,
  // causing the function to be called multiple times and reselecting the text.
  // Context here: https://github.com/PSP-Metrics/web/pull/350/files#r2388738001
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  const handleSaveClick = async (values: { fullName: string }) => {
    if (!candidateToRename.claimedByUser?.userId) {
      notification.error({
        message: "This candidate can't be renamed as they haven't claimed their invite yet.",
      });
      onClose();
      return null;
    }
    setIsLoading(true);
    onRenameCandidate(candidateToRename.claimedByUser.userId, values.fullName, onRenameSuccess, onRenameFailure);
  };

  const onRenameSuccess = () => {
    onClose();
    setIsLoading(false);
  };

  const onRenameFailure = () => {
    setIsLoading(false);
  };

  return (
    <Modal visible={true} onCancel={onClose} footer={null} destroyOnClose={true}>
      <Form
        form={form}
        name="renameUser"
        onFinish={handleSaveClick}
        requiredMark={false}
        layout="vertical"
        initialValues={{ fullName: candidateToRename.candidateFullName || "" }}
      >
        <div>
          <h1>Edit Name</h1>
          <div>
            <Form.Item
              className={style.inputContainer}
              name="fullName"
              label="Full Name"
              rules={[{ required: true, message: "Please enter a full name" }]}
              colon={false}
              labelAlign="left"
            >
              <CustomInput ref={inputRef} className={style.input} />
            </Form.Item>
            <div className={style.actionButtons}>
              <Button colorType={ButtonColorType.light} onClick={onClose}>
                Cancel
              </Button>
              <SubmitButton isLoading={isLoading}>Save</SubmitButton>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
